module.exports = __webpack_public_path__ + "img/more-icon.d22f1f68.svg";